import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { FlatInspectionCategoryResultDto } from '../core/api/model/flatInspectionCategoryResultDto';
import { FlatInspectionResultDto } from '../core/api/model/flatInspectionResultDto';
import { I18NText } from '../core/api/model/i18NText';
import { InspectionElementDto } from '../core/api/model/inspectionElementDto';
import { InspectionCategoryCacheService } from '../core/cache/inspection-category-cache-service';
import { InspectionResultType } from '../core/api/model/inspectionResultType';
import { TranslateDirective } from '@ngx-translate/core';
import { NgClass, KeyValuePipe } from '@angular/common';
import { AutofocusDirective } from '../autofocus/autofocus.directive';
import { I18nTextPipe } from '../core/pipes/i18n-text.pipe';

@Component({
  selector: 'app-status-change-dialog',
  templateUrl: './status-change-dialog.component.html',
  imports: [
    TranslateDirective,
    NgClass,
    NgbCollapse,
    AutofocusDirective,
    KeyValuePipe,
    I18nTextPipe,
  ],
})
export class StatusChangeDialogComponent {
  protected modal = inject(NgbActiveModal);
  private inspectionCategoryCacheService = inject(InspectionCategoryCacheService);

  @Input()
  public notDefinedPointsMap!: Map<string, FlatInspectionResultDto[]>;

  @Input()
  public categoriesWithMissingDefectSeverity!: FlatInspectionCategoryResultDto[];

  @Input()
  public categoriesWithMissingDefectDescription!: FlatInspectionCategoryResultDto[];

  @Input()
  public categoriesWithMissingSanctionDescription!: FlatInspectionCategoryResultDto[];

  @Input()
  public furtherActionSelectionValid!: boolean;

  public inspectionCategories: InspectionElementDto[] | undefined;

  public categoriesWithMissingDefectSeverityDetailsCollapsed = true;

  public categoriesWithMissingDefectDescriptionDetailsCollapsed = true;

  public categoriesWithMissingSanctionDescriptionDetailsCollapsed = true;

  public undefinedPointsDetailsCollapsed = true;

  public constructor() {
    this.inspectionCategories = this.inspectionCategoryCacheService.getInspectionCategories();
  }

  public getNumberOfUndefinedPoints(): number {
    let numberOfUndefinedPoints = 0;
    this.notDefinedPointsMap.forEach((points) => (numberOfUndefinedPoints += points.length));
    return numberOfUndefinedPoints;
  }

  public getCategoryName(categoryNumber: string): I18NText {
    return (
      this.inspectionCategories?.find((category) => category.number === categoryNumber)?.name || {
        germanText: '',
        frenchText: '',
        italianText: '',
      }
    );
  }

  public getCategoryShortName(categoryNumber: string): I18NText {
    return this.inspectionCategoryCacheService.getInspectionCategoryShortName(categoryNumber);
  }

  public setResultsToOK(): void {
    this.notDefinedPointsMap.forEach((points) =>
      points.forEach((point) => {
        if (point.inspectionResult === InspectionResultType.NotDefined) {
          // @ts-expect-error: strict null check ignored intentionally
          point.inspectionResult = null;
        }
      }),
    );
    this.modal.close();
  }

  public setResultsToNK(): void {
    this.notDefinedPointsMap.forEach((points) =>
      points.forEach((point) => {
        if (point.inspectionResult === InspectionResultType.NotDefined) {
          point.inspectionResult = InspectionResultType.NotControlled;
        }
      }),
    );
    this.modal.close();
  }

  public showNotDefinedPointsMap(): boolean {
    return (
      this.notDefinedPointsMap?.size > 0 &&
      !this.categoriesWithMissingDefectSeverity?.length &&
      !this.categoriesWithMissingDefectDescription?.length &&
      !this.categoriesWithMissingSanctionDescription?.length &&
      this.furtherActionSelectionValid
    );
  }
}
